(ns ui.components.alert.view)

(defn danger
  [{:keys [on-close]} & children]
  [:div
   {:class-name "py-4 px-3 mb-0
                 text-sm relative
                 text-danger-light-text
                 bg-danger-light
                 rounded-md"}
   [:div
    {:class-name "flex items-start gap-4"}
    [:div
     {:class-name "text-danger-light-text-accent"}
     [:i.fas.fa-exclamation-circle.text-xl]]
    [:div
     {:class-name "pt-1"}
     (into
      [:div
       {:class-name ""}]
      children)]]
   (when (fn? on-close)
     [:div
      {:class-name "absolute top-3 right-3 hover:opacity-50 cursor-pointer"
       :on-click   on-close}
      [:i.fal.fa-times.text-2xl]])])

(defn warning
  [{:keys [on-close]} & children]
  [:div
   {:class-name "py-4 px-3 mb-0
                 relative
                 text-sm text-warning-light-text-accent
                 bg-warning-light
                 rounded-md"}
   [:div
    {:class-name "flex items-start gap-4"}
    [:div
     {:class-name "text-warning-light-text-accent"}
     [:i.fas.fa-exclamation-circle.text-xl]]
    [:div
     {:class-name "pt-1"}
     (into
      [:div
       {:class-name ""}]
      children)]]
   (when (fn? on-close)
     [:div
      {:class-name "absolute top-3 right-3 hover:opacity-50 cursor-pointer"
       :on-click   on-close}
      [:i.fal.fa-times.text-2xl]])])

(defn info
  [{:keys [on-close]} & children]
  [:div
   {:class-name "py-4 px-3 mb-0
                 relative
                 text-sm text-info-light-text-accent
                 bg-info-light
                 rounded-md"}
   [:div
    {:class-name "flex items-start gap-4"}
    [:div
     {:class-name "text-info-light-text-accent"}
     [:i.fas.fa-exclamation-circle.text-xl]]
    [:div
     {:class-name "pt-1 w-full"}
     (into
      [:div
       {:class-name ""}]
      children)]]
   (when (fn? on-close)
     [:div
      {:class-name "absolute top-3 right-3 hover:opacity-50 cursor-pointer"
       :on-click   on-close}
      [:i.fal.fa-times.text-2xl]])])
